import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LogOut, Shield } from 'lucide-react';
import './Header.css';

const Header = ({ isPublic }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/admin/login');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return (
    <header className="header">
      <div className="container header-content">
        <Link to="/" className="header-logo">
          <Shield size={32} color="#F58220" />
          <div className="header-title">
            <h1>Gauss Control</h1>
            <p>Sistema de Denuncias Anónimas</p>
          </div>
        </Link>
        
        {!isPublic && user && (
          <div className="header-user">
            <span className="user-email">{user.email}</span>
            <button onClick={handleLogout} className="btn btn-secondary">
              <LogOut size={18} />
              Cerrar Sesión
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
